export type CatalogCategory = {
  id: string;
  name: string;
  parentId?: string;
  sortOrder?: number;
};

export const categoryPath = (
  categories: CatalogCategory[],
  id: string,
  seen: Set<string> = new Set(),
): string => {
  const category = categories.find(item => item.id === id);
  if (!category) return '';
  if (seen.has(id) || !category.parentId) return category.name;
  seen.add(id);
  const parent = categoryPath(categories, category.parentId, seen);
  return parent ? `${parent} / ${category.name}` : category.name;
};

export const categoryDepth = (
  categories: CatalogCategory[],
  id: string,
  seen: Set<string> = new Set(),
): number => {
  const category = categories.find(item => item.id === id);
  if (!category?.parentId || seen.has(id)) return 0;
  seen.add(id);
  return 1 + categoryDepth(categories, category.parentId, seen);
};

export const sortedCategories = (categories: CatalogCategory[]): CatalogCategory[] =>
  [...categories].sort((left, right) => {
    const byPath = categoryPath(categories, left.id).localeCompare(categoryPath(categories, right.id), undefined, { sensitivity: 'base' });
    if (byPath !== 0) return byPath;
    return (left.sortOrder ?? 0) - (right.sortOrder ?? 0);
  });
